import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import SEOHead from '../components/SEOHead'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import { Clients, WorkflowShowcase, SoftwareShowcase } from '../components/Projects'
import Problem from '../components/Problem'
import About from '../components/About'
import Services from '../components/Services'
import Process from '../components/Process'
import Pricing from '../components/Pricing'
import Results from '../components/Results'
import FAQ from '../components/FAQ'
import CTA from '../components/CTA'

const Home = () => {
  const { hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    } else {
      window.scrollTo(0, 0)
    }
  }, [hash])

  return (
    <main>
      <SEOHead />
      <Hero />
      <Clients />
      <WorkflowShowcase />
      <SoftwareShowcase />
      <Problem />
      <About />
      <Services />
      <Process />
      <Pricing />
      <Results />
      <FAQ />
      <CTA />
    </main>
  )
}

export default Home
